import { Button } from '@mantine/core';
import { MdArchive } from 'react-icons/md';
import { Message, MessagePatch, MessageStatus } from '../types';

interface ArchiveButtonProps {
    message: Message;
    onArchive: (patch: MessagePatch) => void;
}

export const ArchiveButton = ({ onArchive }: ArchiveButtonProps) => {
    const handleClick = () => {
        onArchive({ status: MessageStatus.ARCHIVED });
    };

    return (
        <Button
            leftSection={<MdArchive />}
            onClick={handleClick}
            variant="light"
        >
            Archive
        </Button>
    );
};
